// extracted by mini-css-extract-plugin
export default {"area":"textArea_area__lHFH8","suggestItem":"textArea_suggestItem__1RvWO"};